import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';

function Contact() {
    const form = useRef();
    const [captchaValue, setCaptchaValue] = useState(null);

    const sendEmail = (e) => {
        e.preventDefault();

        const formData = new FormData(form.current);
        const name = formData.get('name');
        const email = formData.get('email');
        const phone = formData.get('phone');
        const subject = formData.get('subject');
        const message = formData.get('message');

        // Validación básica
        if (!name || !email || !phone || !subject || !message) {
        Swal.fire({
            icon: 'warning',
            title: 'Campos obligatorios',
            text: 'Por favor, completa todos los campos del formulario.',
        });
        return;
        }

        if (!captchaValue) {
        Swal.fire({
            icon: 'warning',
            title: 'Verificación requerida',
            text: 'Por favor, verifica el reCAPTCHA antes de enviar.',
        });
        return;
        }

        // Envío del correo
        emailjs.sendForm('default_service', 'template_t724u5w', form.current, '1_kv6riGk1Cp3apr5')
        .then(() => {
            Swal.fire({
            icon: 'success',
            title: '¡Gracias por tu contacto!',
            text: 'Nos pondremos en contacto contigo pronto.',
            });
            form.current.reset();
            setCaptchaValue(null);
        }, (error) => {
            Swal.fire({
            icon: 'error',
            title: 'Error al enviar',
            text: 'Intenta nuevamente más tarde. Detalles: ' + error.text,
            });
        });
    };

    return (
        <>
        <section class="content-inner">
			<div class="container">
				<div class="row g-xl-4 align-items-center">
					<div class="col-xl-7 pe-xl-4 m-b10">
						<div class="section-head style-1 m-b30">
							<h2 class="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.5s">Optimiza tus <span class="text-primary">procesos legales</span> <br/>  y de <span class="text-primary">atención</span> con un solo aliado.</h2>
							<p class="small wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.5s">Cuéntanos tus necesidades y déjanos guiarte hacia una solución efectiva.</p>
						</div>
						<div class="row">
							<div class="col-md-6 m-b20 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.5s">
								<div class="icon-bx-wraper style-8 box-hover">
									<div class="icon-bx">
										<span class="icon-cell">
											<i class="feather icon-map-pin"></i>						
										</span>
									</div>
									<div class="icon-content">
										<h4 class="dz-title">Dirección</h4>
										<p>Napoles, Benito Juarez, Ciudad de México</p>
									</div>
								</div>
							</div>
							<div class="col-md-6 m-b20 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.5s">
								<div class="icon-bx-wraper style-8 box-hover">
									<div class="icon-bx">
										<span class="icon-cell">
											<i class="feather icon-phone"></i>							
										</span>
									</div>
									<div class="icon-content">
										<h4 class="dz-title">Llamanos</h4>
										<p><a href="tel:+525578326653" class="text-body">5578326653</a></p>
									</div>
								</div>
							</div>
							<div class="col-md-6 m-b20 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.5s">
								<div class="icon-bx-wraper style-8 box-hover">
									<div class="icon-bx">
										<span class="icon-cell">
											<i class="feather icon-mail"></i>
										</span>
									</div>
									<div class="icon-content">
										<h4 class="dz-title">Envianos un Mail</h4>
										<p>
											<a href="mailto:contacto@conectaycrece.com.mx" class="text-body">contacto@conectaycrece.com.mx</a>
										</p>
									</div>
								</div>
							</div>
							<div class="col-md-6 m-b20 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.5s">
								<div class="icon-bx-wraper style-8 box-hover">
									<div class="icon-bx">
										<span class="icon-cell">
											<i class="feather icon-clock"></i>								
										</span>
									</div>
									<div class="icon-content">
										<h4 class="dz-title">Horarios de atención</h4>
										<p>Lun-Vie: 8:00 am - 6:00 pm</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 m-b30" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)">
						<div class="form-wrapper style-1">
							<div class="form-body bg-primary background-blend-burn" style={{backgroundimage: 'url(images/background/bg2.png)', backgroundsize: 'cover'}}>
								<div class="section-head style-1 m-b30">
									<h2 class="title text-white m-b0">Contactanos</h2>
								</div>
								<form ref={form} onSubmit={sendEmail} className="dzForm" id="form">
                                    <input type="hidden" className="form-control" name="dzToDo" value="Contact" />
                                    <input type="hidden" className="form-control" name="reCaptchaEnable" value="0" />
                                    <div className="dzFormMsg"></div>
                                    <div className="row">
                                        <div className="col-sm-12 m-b30">
                                        <div className="form-floating floating-underline input-light">
                                            <input name="name" type="text" className="form-control" placeholder="Ingresa tu Nombre completo" />
                                            <label>Nombre completo</label>
                                        </div>
                                        </div>
                                        <div className="col-sm-6 m-b30">
                                        <div className="form-floating floating-underline input-light">
                                            <input name="email" type="email" className="form-control" placeholder="Ingresa Correo electrónico" />
                                            <label>Correo electrónico</label>
                                        </div>
                                        </div>
                                        <div className="col-sm-6 m-b30">
                                        <div className="form-floating floating-underline input-light">
                                            <input name="phone" type="text" className="form-control dz-number" placeholder="Ingresa tu numero de teléfono" maxLength={10} />
                                            <label>Teléfono</label>
                                        </div>
                                        </div>
                                        <div className="col-sm-12 m-b30">
                                        <div className="form-floating floating-underline input-light">
                                            <input name="subject" type="text" className="form-control" placeholder="Asunto" />
                                            <label>Asunto</label>
                                        </div>
                                        </div>
                                        <div className="col-sm-12 m-b30">
                                        <div className="form-floating floating-underline input-light">
                                            <textarea name="message" className="form-control" rows="4" placeholder=""></textarea>
                                            <label>Mensaje</label>
                                        </div>
                                        </div>
                                        <div className="col-sm-12 m-b30">
                                        <ReCAPTCHA
                                            sitekey="6LfmP1orAAAAAEchyfWq4Jfl1uEu6jrrixytZ46c"
                                            onChange={(value) => setCaptchaValue(value)}
                                        />
                                        </div>
                                        <div className="col-sm-12">
                                        <button type="submit" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow" style={{ float: 'right' }}>
                                            Enviar <span className="right-icon"><i className="feather icon-arrow-right"></i></span>
                                        </button>
                                        </div>
                                    </div>
                                </form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}

export default Contact